// extracted by mini-css-extract-plugin
export default {"container":"toggleSwitch_container__BN1qT","circle":"toggleSwitch_circle__OUJNE","circle_on":"toggleSwitch_circle_on__Iw0LX"};